import { render, staticRenderFns } from "./DisputeTraces.vue?vue&type=template&id=1b7c4bea"
import script from "./DisputeTraces.vue?vue&type=script&lang=js"
export * from "./DisputeTraces.vue?vue&type=script&lang=js"
import style0 from "./DisputeTraces.vue?vue&type=style&index=0&id=1b7c4bea&prod&lang=scss"
import style1 from "./DisputeTraces.vue?vue&type=style&index=1&id=1b7c4bea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports